import { GetApplicationResponse } from '@iwoca/lapi-client/edge';

import { createValidatorFromYupSchema } from './stepValidators';
import { TNormalisedStepData } from '../../../types';
import { minimumCompanyDataSchema } from '../../CompanyDetails/CompanyDetailsUK/CompanyDetailsUK.schema';
import { minimumPersonalDataSchema } from '../../PersonalDetails/PersonalDetailsUK/PersonalDetailsUK.schema';

export const passesStep0Validation = (
  normalisedStep0State: TNormalisedStepData['new'],
  applicationData: GetApplicationResponse['data'],
) => {
  const hasEmail = Boolean(normalisedStep0State.email);
  const hasAmount = Boolean(applicationData?.requested_products?.[0].amount);

  return hasEmail && hasAmount;
};

export const businessStepValidator = createValidatorFromYupSchema(
  minimumCompanyDataSchema,
);

export const personalStepValidator = createValidatorFromYupSchema(
  minimumPersonalDataSchema,
);
